module.exports = __webpack_public_path__ + "static/media/calendar-today.45e77de0.svg";